<div class="amount-currency" [ngClass]="{'amount-currency--left': currencyPosition === 'left'}">
  <ng-content select="[amount]"></ng-content>
  <ng-content select="[currency]"></ng-content>
</div>
